//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import M_DCM_BASIC from './M_DCM_BASIC';
import M_DCM_BASIC_01F from '../M_DCM_BASIC_01/M_DCM_BASIC_01F';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { useSearch1 } from './M_DCM_BASIC_Query';
//#endregion

export default function M_DCM_BASICF() {
  //#region 변수
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [selectedMenuId, setSelectedMenuId] = useState(null);
  const [selectedSubMenuId, setSelectedSubMenuId] = useState(null);
  const [menuStructure, setMenuStructure] = useState([]);

  const searchRef = useRef({
    mainMenuId: null,
    subMenuId: null,
    searchText: '',
  });
  //#endregion

  //#region 이벤트
  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Init = () => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('문서 관리'));
    dispatch(CommonActions.setActiveStep(0));
  };
  //#endregion

  //#region 쿼리
  const { refetch: Search1, isLoading: loading } = useSearch1({
    onSuccess: (rows) => {
      if (!Array.isArray(rows)) {
        setMenuStructure([]);
        return;
      }

      // screenType이 "0"인 메뉴들만 필터링 (관리자 웹 메뉴)
      const adminMenus = rows.filter((item) => item.screenType === '0');

      // 대메뉴/중메뉴 구조 생성
      const mainMenus = adminMenus.filter((item) => item.menuType === '0');
      const subMenus = adminMenus.filter((item) => item.menuType === '1');

      //#region 임시 필터링 코드 (다른 웹페이지 작업 미완료로 인한 숨김 처리 작업 완료 시 원복)
      const documentMainMenuIds = [
        'SafetySystem',
        'RiskEvaluation',
        'SafeWork',
        'Training',
        'HealthManagement',
        'Accidents',
      ];

      const documentMainMenus = mainMenus.filter((menu) =>
        documentMainMenuIds.includes(menu.menuId)
      );

      const menuStructureData = documentMainMenus.map((mainMenu) => {
        const subMenuList = subMenus
          .filter((subMenu) => subMenu.menuUp === mainMenu.menuId)
          .sort((a, b) => a.seq - b.seq)
          .map((subMenu) => ({
            id: subMenu.menuId,
            name: subMenu.menuNm,
          }));

        return {
          id: mainMenu.menuId,
          name: mainMenu.menuNm,
          subMenus: subMenuList,
        };
      });
      //#endregion

      // //#region 임시 필터링 코드 (다른 웹페이지 작업 미완료로 인한 숨김 처리 추후 삭제)
      // // 문서 관리 관련 대메뉴 ID 목록
      // const documentMainMenuIds = [
      //   'SafetySystem', // 안전보건관리체계
      //   // 'RiskEvaluation', // 위험성평가 (작업 미완료로 숨김)
      //   'SafeWork', // 안전작업 관리
      //   'TrainingPage', // 교육 및 훈련
      //   'HealthManagement', // 보건관리
      //   'Accidents', // 산업재해
      // ];

      // // 허용된 중메뉴 ID 목록 (다른 웹페이지 작업 미완료로 인한 임시 필터링)
      // const allowedSubMenuIds = [
      //   'SafetyPersonnel', // 안전보건인력
      //   'EmergencyManual', // 비상대응매뉴얼
      //   'SafetyWorkManagement', // 안전작업 관리(작업종류별)
      //   'SafeWorkProcedure', // 안전작업 관리
      //   'HazardousMaterials', // 유해·위험물질
      //   'WorkEnvironment', // 작업환경측정
      //   'MusculoskeletalSurvey', // 근골격계질환 유해요인조사
      //   'AccidentReport', // 산업재해 보고 및 기록
      // ];

      // // 문서 관리 관련 대메뉴만 필터링
      // const documentMainMenus = mainMenus.filter((menu) =>
      //   documentMainMenuIds.includes(menu.menuId)
      // );

      // // 대메뉴별로 중메뉴 매핑 (허용된 중메뉴만 표시)
      // const menuStructureData = documentMainMenus
      //   .map((mainMenu) => {
      //     const subMenuList = subMenus
      //       .filter((subMenu) => {
      //         // 대메뉴에 속하고, 허용된 중메뉴 ID인 경우만 표시
      //         return (
      //           subMenu.menuUp === mainMenu.menuId &&
      //           allowedSubMenuIds.includes(subMenu.menuId)
      //         );
      //       })
      //       .sort((a, b) => a.seq - b.seq)
      //       .map((subMenu) => ({
      //         id: subMenu.menuId,
      //         name: subMenu.menuNm,
      //       }));

      //     // TrainingPage는 중메뉴가 없어도 표시 (대메뉴 자체를 클릭 가능)
      //     if (
      //       mainMenu.menuId === 'TrainingPage' &&
      //       subMenuList.length === 0
      //     ) {
      //       return {
      //         id: mainMenu.menuId,
      //         name: mainMenu.menuNm,
      //         subMenus: [],
      //       };
      //     }

      //     // 중메뉴가 있는 대메뉴만 반환 (중메뉴가 없으면 숨김)
      //     if (subMenuList.length === 0) {
      //       return null;
      //     }

      //     return {
      //       id: mainMenu.menuId,
      //       name: mainMenu.menuNm,
      //       subMenus: subMenuList,
      //     };
      //   })
      //   .filter((menu) => menu !== null); // null 제거
      // //#endregion

      // seq 순서로 정렬
      menuStructureData.sort((a, b) => {
        const menuA = mainMenus.find((m) => m.menuId === a.id);
        const menuB = mainMenus.find((m) => m.menuId === b.id);
        return (menuA?.seq || 0) - (menuB?.seq || 0);
      });

      setMenuStructure(menuStructureData);
    },
  });
  //#endregion

  //#region 나머지 함수
  const HandleMenuSelect = (mainMenuId, subMenuId) => {
    setSelectedMenuId(mainMenuId);
    setSelectedSubMenuId(subMenuId);
    searchRef.current.mainMenuId = mainMenuId;
    searchRef.current.subMenuId = subMenuId;
    dispatch(CommonActions.setActiveStep(1));
  };

  const HandleBack = () => {
    setSelectedMenuId(null);
    setSelectedSubMenuId(null);
    searchRef.current.mainMenuId = null;
    searchRef.current.subMenuId = null;
    dispatch(CommonActions.setActiveStep(0));
  };
  //#endregion

  // activeStep이 1일 때 문서 리스트 화면 표시
  if (activeStep === 1 && (selectedMenuId || selectedSubMenuId)) {
    return (
      <M_DCM_BASIC_01F
        mainMenuId={selectedMenuId}
        subMenuId={selectedSubMenuId}
        onBack={HandleBack}
      />
    );
  }

  // activeStep이 0일 때 메뉴 선택 화면
  if (activeStep === 0) {
    return (
      <M_DCM_BASIC
        userInfo={userInfo}
        searchRef={searchRef}
        onMenuSelect={HandleMenuSelect}
        menuStructure={menuStructure}
        loading={loading}
      />
    );
  }

  return null;
}
